export default {
  add: {
    id: 'bo_seller-options-shipping-rule_drawer-add',
    defaultMessage: 'Add',
  },
  backshipOptions: {
    id: 'bo_seller.options.shipping.add-method.backship_options',
    defaultMessage: 'Backship Options: {count}',
  },
} as const
